// See
// comporent: smooth-internal-links for a more general implementation

import { gsap } from "gsap";

import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollSmoother } from "gsap/dist/ScrollSmoother";

import "./styles.scss";

gsap.registerPlugin(ScrollTrigger, ScrollSmoother);

class SmoothInternalLinks {
  constructor(smoother, internalLinkClass) {
    this.internalLinkClass = internalLinkClass || "internal-link";
    this.smoother = smoother.gsapSmoothScroller;
    this.tocLinks = [...document.querySelectorAll(`.${this.internalLinkClass}`)];
    if (!this.tocLinks) return;
    this.addEvents();
  }
  handleAnchorClick = (e) => {
    const id = e.target.getAttribute("href");
    console.log(this.smoother);
    // GGF parametrisierung über data attribute der Geschwindigkeit möglich
    gsap.to(this.smoother, {
      scrollTop: this.smoother.offset(id, "-80 top"),
      duration: 3,
    });

    this.smoother.scrollTo(id, true, "-80 top");
    e.preventDefault();
    console.log(e.target);
  };
  handleExternalUrlWithHash = (e) => {
    const urlHash = window.location.href.split("#")[1];
    const scrollElem = document.querySelector("#" + urlHash);

    if (urlHash && scrollElem) {
      gsap.to(this.smoother, {
        scrollTop: this.smoother.offset(scrollElem, "-80 top"),
        duration: 1,
        delay: 0.5,
      });
    }
  };
  addEvents() {
    this.tocLinks.forEach((link) => link.addEventListener("click", this.handleAnchorClick));
    window.addEventListener("load", this.handleExternalUrlWithHash);
  }
}

export { SmoothInternalLinks };
